export default {
  states: [],
  location: {
    id: 0,
    accountNumber: null,
    name: null,
    timeZone: null,
    stateID: null,
    /**
     * This is where the file selected in the input is stored
     * @type {Array} - Array of File() objects
     */
    logo: [],
    /**
     * This is only used when we get data from the API.
     * @example "image/png"
     */
    logoContentType: null,
    /**
     * File converted as base64. Used to display the image in DOM
     */
    logoBase64: null
  },
  locations: [],
  kpiStats: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/location/state.js